import { Schema } from '@rossum/api-client/schemas';
import { Workspace } from '@rossum/api-client/workspaces';
import { Queue } from '../types/queue';

export const createWorkspaceOptions = (
  workspaces: Workspace[],
  queues: Queue[],
  schemas: Schema[]
) => {
  return workspaces
    .filter(workspace => workspace.queues.length > 0)
    .map(workspace => ({
      id: `workspaceId:${workspace.id}`,
      label: workspace.name,
      options: workspace.queues.flatMap(queueUrl => {
        const queue = queues.find(q => q.url === queueUrl);
        if (!queue) return [];

        const schema = schemas.find(s => s.url === queue.schema);
        if (!schema || !schema.content || schema.content.length === 0)
          return [];

        return [
          {
            id: `workspaceId:${workspace.id}.queueId:${queue.id}.schemaId:${schema.id}`,
            label: queue.name,
            options: schema.content.flatMap(content => {
              // To achieve the desired behaviour, on a schema option level the structure is flat
              const multivalues = content.children
                .filter(
                  child =>
                    child.category === 'multivalue' &&
                    child.children.category === 'tuple'
                )
                .map(multivalue => ({
                  id: `workspaceId:${workspace.id}.schemaId:${schema.id}.sectionId:${content.id}.multivalueId:${multivalue.id}`,
                  label: `${multivalue.label} (${multivalue.category === 'multivalue' ? 'line items' : multivalue.category})`,
                }));

              return [
                {
                  id: `workspaceId:${workspace.id}.schemaId:${schema.id}.sectionId:${content.id}`,
                  label: `${content.label} (${content.category})`,
                },
                ...multivalues,
              ];
            }),
          },
        ];
      }),
    }))
    .filter(o => o.options.length !== 0);
};
